module.exports = __webpack_public_path__ + "static/img/p8.0580641.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/partner/p8.png
// module id = FLU7
// module chunks = 0